import { clsx } from 'clsx';
import * as style from './styles.css';
import { Button, Label, Responsive } from '@cian/ui-kit';
import { TWithModalProps } from 'shared/common/types/components';
import { EModalSource } from 'shared/common/types/modal';

type TByCianStatisticsProps = TWithModalProps;

export const ByCianStatistics: React.FC<TByCianStatisticsProps> = ({ device, onOpenModal }) => {
  return (
    <div className={clsx(style['container'], style[device])}>
      <div className={style['title']}>Мы всё посчитали </div>
      <div className={style['list']}>
        <div className={style['item']}>
          <div className={style['textblock']}>
            <Label background="accent-positive-secondary" color="accent-positive-primary">
              Аналитика Циана
            </Label>
            <div className={style['percent-image']} />
            {/* eslint-disable-next-line no-irregular-whitespace */}
            <div className={style['descr']}>объектов в 2024 г. продали с риелтором</div>
          </div>
          <div className={clsx(style['image'], style['building'])} />
        </div>
        <div className={style['item']}>
          <div className={style['textblock']}>
            <Label background="accent-positive-secondary" color="accent-positive-primary">
              Аналитика Циана
            </Label>
            <div className={style['week-image']} />
            <div className={style['descr']}>быстрее проходит сделка с риелтором</div>
          </div>
          <div className={clsx(style['image'], style['calendar'])} />
        </div>
      </div>
      <Responsive phone>
        <div className={style['btn']}>
          <Button onClick={() => onOpenModal(EModalSource.Consultation)} fullWidth size="L">
            Получить консультацию
          </Button>
        </div>
      </Responsive>
    </div>
  );
};
